import styled from 'styled-components';

// ======================================
// Please note:
//    These components also exist within the main Arcade Strange repo: https://github.com/Arcade-Strange/arcade-strange-webapp
//    They have been duplicated here as a quick solution to utilise them within a different application
//    This is not an optimal solution if more and more components are needed, consider a git submodule or Storybook
// ======================================

export const Input = styled.input`
  position: relative;
  border: none;
  background: none;
  outline: none;

  padding: 14px;
  border: double 3px transparent;
  border-radius: 14px;
  background-image: linear-gradient(#2e2b3b, #2e2b3b),
    linear-gradient(
      93.41deg,
      #1d1c20 0%,
      #ff52e3 20.68%,
      #f2f0ff 50.81%,
      #6ffff6 76.85%,
      #1f1a3e 100%
    );
  background-origin: border-box;
  background-clip: padding-box, border-box;
  color: #f2f0ff;
`;

const noise = 'url(/images/grain.svg)';

export const Button = styled.button`
  background: none;
  outline: none;
  border: none;
  background-color: ${(p) => p.theme.colors.bg}88;
  color: ${(p) => p.theme.colors.bg};
  padding: 12px 64px;
  cursor: pointer;

  text-transform: uppercase;
  font-weight: 600;
  font-size: 20px;
  font-family: 'Bevellier';
  letter-spacing: 0.105em;

  background: ${noise},
    linear-gradient(
      93.41deg,
      #434053 0%,
      #ff52e3 20.68%,
      #f2f0ff 50.81%,
      #6ffff6 76.85%,
      #1f1a3e 100%
    );
  box-shadow: 0px -1px 0px 0.1px #ffffff, 0px 1px 0px #000000;
  border-radius: 16px;
  position: relative;
  width: 100%;
  filter: contrast(140%) brightness(110%);
`;

export const ButtonContainer = styled.button`
  background: none;
  outline: none;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = (): JSX.Element => (
  <svg viewBox="0 0 432 55" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_653_2317)">
      <rect
        x="141"
        y="28.5"
        width="138"
        height="2"
        transform="rotate(180 141 28.5)"
        fill="url(#paint0_linear_653_2317)"
      />
      <rect
        x="141"
        y="28.5"
        width="138"
        height="2"
        transform="rotate(180 141 28.5)"
        fill="url(#paint1_linear_653_2317)"
      />
    </g>
    <rect
      x="141"
      y="28.5"
      width="138"
      height="2"
      transform="rotate(180 141 28.5)"
      fill="url(#paint2_linear_653_2317)"
    />
    <path
      d="M181.708 11.3789H169.354V43.6203H181.708V11.3789Z"
      fill="#3A0CA3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M181.708 0V11.3793H169.354L181.708 0Z"
      fill="#7209B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M169.354 55V43.6207H181.708L169.354 55Z"
      fill="#3F37C9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M181.708 11.3789H194.062V33.7815L181.708 43.6203V11.3789Z"
      fill="#4CC9F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M169.354 43.6191H157V21.7357L169.354 11.4287V43.6191Z"
      fill="#F72585"
    />
    <path
      d="M212.72 34.5042C215.601 34.5042 217.719 33.0902 217.719 30.6422C217.719 28.5106 216.49 27.4554 214.055 26.9912L211.64 26.5269C210.094 26.2314 209.226 25.8093 209.226 24.5009C209.226 23.0236 210.306 22.1161 212.233 22.1161C214.436 22.1161 215.77 23.3613 215.834 25.5561L217.507 25.4717C217.486 22.4749 215.558 20.7021 212.212 20.7021C209.29 20.7021 207.447 22.285 207.447 24.6064C207.447 26.6746 208.802 27.7298 210.772 28.1097L213.419 28.6162C215.156 28.9538 215.961 29.5447 215.961 30.7688C215.961 32.225 214.711 33.0691 212.72 33.0691C210.476 33.0691 208.802 31.824 208.697 29.397L207.045 29.5025C207.045 32.7103 209.438 34.5042 212.72 34.5042ZM222.578 37.7964L227.915 25.0285H226.178L223.34 32.1194H223.255L220.312 25.0285H218.469L222.366 34.2298L220.862 37.7964H222.578ZM230.889 34.2509V28.9538C230.889 27.2655 231.99 26.1681 233.388 26.1681C234.849 26.1681 235.591 27.1389 235.591 28.6795V34.2509H237.348V28.5317C237.348 26.3791 236.374 24.7752 233.96 24.7752C232.583 24.7752 231.334 25.5561 230.889 26.6746V25.0285H229.131V34.2509H230.889ZM243.669 34.5042C245.977 34.5042 247.523 33.2379 247.989 31.1486L246.528 30.9798C246.147 32.3938 245.236 33.1324 243.69 33.1324C242.038 33.1324 240.746 31.8662 240.662 30.0723H248.032V29.3759C248.032 26.8645 246.528 24.7752 243.584 24.7752C240.916 24.7752 238.904 26.8645 238.904 29.7769C238.904 32.647 240.916 34.5042 243.669 34.5042ZM246.231 28.9327H240.704C240.916 27.4132 241.911 26.1048 243.584 26.1048C245.342 26.1048 246.168 27.4554 246.231 28.9327ZM251.472 34.2509V29.3759C251.472 27.6032 252.467 26.4002 253.802 26.4002C254.373 26.4002 254.733 26.5058 255.242 26.7801L255.411 25.1973C255.093 24.923 254.67 24.7752 254.098 24.7752C252.764 24.7752 251.811 25.8515 251.472 26.9067V25.0285H249.714V34.2509H251.472ZM259.847 38.0497C262.6 38.0497 265.184 37.1633 265.184 34.863C265.184 33.4279 264.125 32.3727 262.113 32.3727H258.491C257.687 32.3727 257.369 32.0772 257.369 31.5707C257.369 31.1486 257.665 30.8532 257.983 30.6633C258.555 30.9165 259.254 31.0431 260.016 31.0431C262.303 31.0431 263.934 29.8402 263.934 27.9197C263.934 27.3288 263.765 26.8012 263.489 26.358C263.955 26.1259 264.654 25.9782 265.268 25.9782V24.4587C264.273 24.4587 263.405 24.9863 262.918 25.7249C262.219 25.134 261.181 24.7752 260.016 24.7752C257.75 24.7752 256.141 25.9782 256.141 27.9197C256.141 28.9327 256.585 29.7558 257.348 30.3045C256.522 30.6633 255.95 31.2331 255.95 32.035C255.95 32.7315 256.331 33.3435 257.178 33.6178C256.035 33.8289 255.272 34.5042 255.272 35.5594C255.272 37.2688 257.348 38.0497 259.847 38.0497ZM260.037 29.9246C258.745 29.9246 257.941 29.2071 257.941 27.9408C257.941 26.6324 258.745 25.9148 260.037 25.9148C261.35 25.9148 262.155 26.6324 262.155 27.9408C262.155 29.2071 261.35 29.9246 260.037 29.9246ZM259.847 36.8889C258.131 36.8889 256.945 36.3825 256.945 35.2217C256.945 34.2298 257.771 33.9133 258.724 33.9133H261.71C262.79 33.9133 263.489 34.2087 263.489 35.0529C263.489 36.3825 261.965 36.8889 259.847 36.8889ZM269.386 37.7964L274.723 25.0285H272.987L270.149 32.1194H270.064L267.12 25.0285H265.278L269.175 34.2298L267.671 37.7964H269.386Z"
      fill="white"
    />
    <g filter="url(#filter1_f_653_2317)">
      <rect
        x="291"
        y="26.5"
        width="138"
        height="2"
        fill="url(#paint3_linear_653_2317)"
      />
      <rect
        x="291"
        y="26.5"
        width="138"
        height="2"
        fill="url(#paint4_linear_653_2317)"
      />
    </g>
    <rect
      x="291"
      y="26.5"
      width="138"
      height="2"
      fill="url(#paint5_linear_653_2317)"
    />
    <defs>
      <filter
        id="filter0_f_653_2317"
        x="0"
        y="23.5"
        width="144"
        height="8"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.5"
          result="effect1_foregroundBlur_653_2317"
        />
      </filter>
      <filter
        id="filter1_f_653_2317"
        x="288"
        y="23.5"
        width="144"
        height="8"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.5"
          result="effect1_foregroundBlur_653_2317"
        />
      </filter>
      <linearGradient
        id="paint0_linear_653_2317"
        x1="141"
        y1="30.5001"
        x2="279"
        y2="30.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CDEDE7" />
        <stop offset="1" stopColor="#C4E5DD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_653_2317"
        x1="141"
        y1="30.5001"
        x2="279"
        y2="30.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF82CD" />
        <stop offset="1" stopColor="#4CC1F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_653_2317"
        x1="141"
        y1="30.5001"
        x2="279"
        y2="30.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF82CD" />
        <stop offset="1" stopColor="#4CC1F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_653_2317"
        x1="291"
        y1="28.5001"
        x2="429"
        y2="28.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CDEDE7" />
        <stop offset="1" stopColor="#C4E5DD" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_653_2317"
        x1="291"
        y1="28.5001"
        x2="429"
        y2="28.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF82CD" />
        <stop offset="1" stopColor="#4CC1F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_653_2317"
        x1="291"
        y1="28.5001"
        x2="429"
        y2="28.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF82CD" />
        <stop offset="1" stopColor="#4CC1F4" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
